import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

// TODO: Currently dangerouslySetHtml -> replace with 
function PageEditorWidget({ widgetId, editable }) {
    const targetWidgetData = useSelector(state => state.dashboard.contentBlockData[widgetId]) || '';
    const pageHTML = useSelector(state => state.dashboard.widgets[widgetId].settings?.html) || '';
    const placeholder = useSelector(state => state.dashboard.widgets[widgetId].settings?.placeholder) || {html: ''};

    const content = useMemo(() => {
        if (!targetWidgetData) {
            return (placeholder.enabled ? placeholder.html : pageHTML);
        }

        let out = pageHTML;
        for (const [k, v] of Object.entries(targetWidgetData)) {
            out = out.replace(k, v);
        }
        return out;
    }, [targetWidgetData, pageHTML, placeholder.html, placeholder.enabled]);

    // Lazily load to render styles properly
    useEffect(() => {
        import('ckeditor5/ckeditor5.css');
    }, []);

    return (
        <>
            <div className='page-editor-widget'>
                <div>
                    <div dangerouslySetInnerHTML={{__html: content || 
                    `<h1>${I18n.t('empty_page')}</h1>
                    <p>${I18n.t('editor_no_content_message')}</p>`
                    }} className='ck ck-content' />
                </div>
            </div>
        </>
    )
}

export default PageEditorWidget;
